exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-hidden[data-v-47148bcb]{visibility:hidden}.w-100[data-v-47148bcb]{width:100%}.text-transform-none[data-v-47148bcb]{text-transform:none}", ""]);

// exports
